<template>
	<inertia-head title="TRC AI Circle Latest Updates" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">TRC AI CIRCLE LATEST UPDATES</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						The Truly Rich Club AI Circle latest updates focus on leveraging AI for work, business, and everyday life — without feeling overwhelmed by the technology.
					</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content mt-5">
		<div v-if="trcAiCircleBlogs.data.length > 0" class="trc-ai-blog-list">
			<!--START Posts -->
			<article v-for="blog in trcAiCircleBlogs.data" :key="blog.ai_circle_blog_uuid" class="trc-ai-blog-card">
				<div class="row align-items-start">
					<div class="col-lg-5 mb-4 mb-lg-0">
						<inertia-link
							:href="'/member/trc-ai-circle/latest-updates/'+blog.ai_circle_blog_uuid"
							class="trc-ai-blog-image-link"
							aria-label="Open blog article"
						>
							<img :src="blog.blog_image_url" class="img-fluid w-100 rounded trc-ai-blog-image" alt="blog image">
						</inertia-link>
					</div>
					<div class="col-lg-7">
						<inertia-link
							:href="'/member/trc-ai-circle/latest-updates/'+blog.ai_circle_blog_uuid"
							class="trc-ai-blog-title"
						>
							{{ blog.blog_title }}
						</inertia-link>
						<inertia-link
							:href="'/member/trc-ai-circle/latest-updates/'+blog.ai_circle_blog_uuid"
							class="trc-ai-blog-summary"
						>
							<div v-html="blog.short_desc"></div>
						</inertia-link>
						<div class="trc-ai-blog-meta">
							<span>{{ blog.author_name }}</span>
							<span class="trc-ai-blog-meta-dot">&bull;</span>
							<span>{{ blog.date_start_display }}</span>
						</div>
					</div>
				</div>
			</article>
			<nav class="d-flex justify-content-between align-items-center push">
				<inertia-link
					v-if="trcAiCircleBlogs.prev_page_url"
					:href="trcAiCircleBlogs.prev_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !trcAiCircleBlogs.prev_page_url }"
				>
					<i class="fa fa-arrow-left opacity-50 me-1"></i>
					<span>Prev</span>
				</inertia-link>
				<inertia-link
					v-if="trcAiCircleBlogs.next_page_url"
					:href="trcAiCircleBlogs.next_page_url"
					class="btn btn-secondary"
					:class="{ disabled: !trcAiCircleBlogs.next_page_url }"
				>
					<span>Next</span>
					<i class="fa fa-arrow-right opacity-50 ms-1"></i>
				</inertia-link>
			</nav>
			<hr class="d-xl-none" />
			<!-- END Posts -->

		</div>
		<div v-else>
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="m-0 h4 text-danger text-center">No Blogs Found...</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import axios from 'axios'
import { debounce } from 'lodash'
import { onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
	props: {
		trcAiCircleBlogs: Object,
	},
	setup(props) {
		const modal 			= ref(null);
		let trcAiCircleBlogs 	= ref(props.trcAiCircleBlogs);

		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')

		})

		
		return {
			modal,
			trcAiCircleBlogs
		}
	},
}
</script>

<style scoped>
.trc-ai-blog-list {
	max-width: 1220px;
	margin: 0 auto;
}

.trc-ai-blog-card {
	padding: 2rem 0;
	border-bottom: 1px solid rgba(33, 37, 41, .12);
}

.trc-ai-blog-card:first-child {
	padding-top: 0;
}

.trc-ai-blog-image-link {
	display: block;
}

.trc-ai-blog-image {
	display: block;
	object-fit: contain;
	background: #fff;
}

.trc-ai-blog-title {
	display: inline;
	color: #1f242b;
	font-size: clamp(1.75rem, 2.8vw, 2.75rem);
	font-weight: 600;
	line-height: 1.12;
	text-decoration: none;
}

.trc-ai-blog-title:hover {
	color: #111827;
	text-decoration: underline;
	text-decoration-color: rgba(31, 36, 43, .22);
	text-underline-offset: .12em;
}

.trc-ai-blog-summary {
	display: block;
	margin-top: 1.35rem;
	color: #2f3540;
	font-size: 1.125rem;
	line-height: 1.45;
	text-decoration: none;
	white-space: break-spaces;
}

.trc-ai-blog-summary:hover {
	color: #1f242b;
}

.trc-ai-blog-summary :deep(p) {
	margin-bottom: 0;
}

.trc-ai-blog-meta {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: .75rem;
	margin-top: 1.35rem;
	color: #2f3540;
	font-size: 1.05rem;
	line-height: 1.4;
}

.trc-ai-blog-meta-dot {
	font-size: .9rem;
}

@media (max-width: 991.98px) {
	.trc-ai-blog-card {
		padding: 1.75rem 0;
	}

	.trc-ai-blog-title {
		font-size: 1.85rem;
	}
}
</style>
